import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '../app.module';

@Component({
  selector: 'app-popup',
  template: `
    <!-- <nb-layout>
      <nb-layout-column class="d-flex align-items-center text-center">
        <nb-card class="border-0 box mx-auto" style="width:37em">
          <nb-card-body class="align-items-cen">
            <nb-auth-block>
              <router-outlet></router-outlet>
            </nb-auth-block>
          </nb-card-body>
        </nb-card>
      </nb-layout-column>
    </nb-layout> -->
    <nb-layout>
      <nb-layout-column class="d-flex">
        <div class="popup-container">
          <router-outlet></router-outlet>
        </div>
      </nb-layout-column>
    </nb-layout>
  `,
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor() { }

  private messageHandler = (event: MessageEvent) => {
    if (event.data?.type === 'close') {
      window.close();
    }
  };

  ngOnInit() {
    window.addEventListener('message', this.messageHandler);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.messageHandler);
  }

  ngAfterViewInit(): void {
    // document.addEventListener('DOMContentLoaded', () => {
    //   platformBrowserDynamic()
    //     .bootstrapModule(AppModule)
    //     .then(() => {
    //       const spinner = document.getElementById('nb-global-spinner');
    //       if (spinner) {
    //         spinner.remove();
    //       }
    //     })
    //     .catch(err => console.error(err));
    // });
    const spinner = document.getElementById('nb-global-spinner');
    if (spinner) {
      spinner.remove();
    }  
  }

}
